import React from 'react'
import MainLayout from '../../components/Layouts/Main/MainLayout.index';
import FW from '../../config/word.json'
import { useEffect } from 'react'; 
import { useNavigate } from 'react-router-dom';

import { MenuList, MenuLink } from './Menu.style'

export default function Menu() {
    
    const navigate = useNavigate();
    // ✅ 初期表示時にAPIからデータ取得
    useEffect(() => {
        const userId = sessionStorage.getItem('userId');
        if (!userId) {
            navigate('/');
            return;
        }
    });
    const menuItems = [
        {
            title: FW.F_W_HOME_ApprovalList,
            path: '/approvallist',
        },
        {
            title: FW.F_W_HOME_ApprovaledList,
            path: '/approvaledlist',
        },
        {
            title: FW.F_W_HOME_RejectList,
            path: '/rejectedlist',
        },
        {
            title: 'バナー管理',
            path: '/bannerManage',
        }
    ];
    return (
        <MainLayout>
            <MenuList>
                {menuItems.map((item, index) =>
                    <MenuLink to={item.path} key={index}>
                        {item.title}
                    </MenuLink>)}
            </MenuList>


        </MainLayout>
    )
}

